// API бьюти-рутины: до записи в Redux отделяет правильный порядок от данных интерфейса.
// Redux получает слоты и перемешанные карточки со случайными ID; ответы остаются в модуле.
// Результат считается при отправке /end и возвращается после успешного ответа сервера.

import { v4 as uuid } from 'uuid'
import { post } from '../utils/api/api'

// Правильный порядок хранится только в модуле, без передачи в Redux.
let routines = new Map()

// Перемешивает карточки, чтобы их порядок не раскрывал ответ.
function shuffle(items) {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[items[i], items[j]] = [items[j], items[i]]
  }
  return items
}

// Удаляет правильное соответствие до создания action с ответом API.
export async function getBeautyRoutine() {
  const payload = await post(
    '/beauty-routine/list',
    {},
    {
      apmCustomErrorMessage: 'Не удалось получить список бьюти-рутины',
    },
  )
  const nextRoutines = new Map()
  const list = (payload?.list ?? []).map((routine) => {
    const sessionId = uuid()
    const cards = (routine.items ?? []).map(({ image, brand, description }) => ({
      id: uuid(),
      image,
      brand,
      description,
    }))
    nextRoutines.set(sessionId, {
      id: routine.id,
      cards: cards.slice(),
      pending: false,
      completed: false,
    })
    // Убираем ответы, сохраняя day_limit и остальные поля для интерфейса.
    const { items, ...rest } = routine
    return {
      ...rest,
      sessionId,
      slots: (items ?? []).map(({ action }) => ({ id: uuid(), action })),
      cards: shuffle(cards),
    }
  })
  routines = nextRoutines
  return { list }
}

// Считает результат и раскрывает его только после успешного /end.
// Надёжную проверку расстановки и попыток должен выполнять сервер.
export async function endBeautyRoutine({ id, sessionId, placement }) {
  const routine = routines.get(sessionId)
  if (!routine || routine.id !== id || routine.pending || routine.completed) {
    throw new Error('Бьюти-рутина недоступна или уже отправлена')
  }
  const ids = new Set(routine.cards.map((card) => card.id))
  if (
    !Array.isArray(placement) ||
    placement.length !== routine.cards.length ||
    new Set(placement).size !== ids.size ||
    placement.some((cardId) => !ids.has(cardId))
  ) {
    throw new Error('Некорректная расстановка карточек бьюти-рутины')
  }
  const result = routine.cards.map((card, index) => ({
    isRight: card.id === placement[index],
    img: routine.cards.find((item) => item.id === placement[index]).image,
  }))
  routine.pending = true
  try {
    const response = await post(
      '/beauty-routine/end',
      {
        id,
        correct_count: result.filter((item) => item.isRight).length,
      },
      { apmCustomErrorMessage: 'Не удалось закончить бьюти-рутину' },
    )
    routine.completed = true
    return { ...response, placementResult: result }
  } finally {
    routine.pending = false
  }
}
